import { TNodeTypes } from "../../models/graph-kn.cm-api-models"
import { BP_Node_Style_Config } from "./graph-node-bp-status-styles"
import { Contract_Node_Style_Config } from "./graph-node-contract-step-styling"
import { Parent_BP_Node_Styling_Config } from "./graph-node-parent-bp-styles"
import { TaskStep_Node_Style_Config } from "./graph-node-task-step-styles"

type TNodesStylesConfigs = typeof BP_Node_Style_Config| typeof Contract_Node_Style_Config | typeof TaskStep_Node_Style_Config
export const NodesStylingMap = new Map<TNodeTypes,TNodesStylesConfigs>([
    ['BPStatus',BP_Node_Style_Config],
    ['TaskStep',TaskStep_Node_Style_Config],
    ['parentBP',Parent_BP_Node_Styling_Config],
    ['childBPStatus',BP_Node_Style_Config],
    ['contractStep',Contract_Node_Style_Config],
    ['subContractStep',Contract_Node_Style_Config]
])